import {Component, Injector} from '@angular/core';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {DeliveryNoteReviewDto} from '../../../../../Models/Documents-review/delivery-note-review.interface';
import {DeliveryNotesReviewFilters} from '../../../../../Models/Documents-review/deliver-note-review-filters.model';
import {DocumentsReviewApiService} from '../../../../../Services/Api/Documents-review/documents-review-api.service';

@Component({
  selector: 'app-delivery-notes-review-widget',
  templateUrl: './delivery-notes-review-widget.component.html',
  styleUrls: ['./delivery-notes-review-widget.component.scss'],
  standalone: false,
})
export class DeliveryNotesReviewWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 6;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected documentsReviewService: DocumentsReviewApiService,
  ) {
    super(injector, documentsReviewService);
  }


  /**
   * Obtener el número de albaranes por revisar
   *
   */
  override setData(data: DeliveryNoteReviewDto[]) {
    this.data = data.length;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const storeId: number = this.widgetsManager.filters ? this.widgetsManager.filters.local?.id : 0;
    return this.documentsReviewService.getDeliveryNotesReview(DeliveryNotesReviewFilters.forReview(storeId));
  }

}
